module.exports = __webpack_public_path__ + "img/20190704161755YY截图20190704013120.32d6881a.png";